module.exports = __webpack_public_path__ + "img/about-shape.d242eaa7.png";